import { Box, Stack, Typography } from '@mui/joy';
import { MEAL_TYPE_LABELS } from '@/features/meals/constants';
import { EmptyMealTypeState } from './EmptyMealTypeState';

export function MealTypeSection({
  mealType,
  entries,
  renderEntry,
  emptyStateText = 'No meals planned',
  isDragging = false,
  children,
}) {
  const isEmpty = !entries || entries.length === 0;

  return (
    <Box>
      <Typography level="title-sm" sx={{ mb: 0.5 }}>{MEAL_TYPE_LABELS[mealType]}</Typography>
      {children ? (
        children
      ) : (
        <>
          {isEmpty ? (
            <EmptyMealTypeState text={emptyStateText} isDragging={isDragging} />
          ) : (
            <Stack gap={0.75}>
              {entries.map((entry, index) => renderEntry(entry, index))}
            </Stack>
          )}
        </>
      )}
    </Box>
  );
}

